module.exports = __webpack_public_path__ + "img/CardImage4.3a77098c.png";